import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTwitter, FaWhatsapp, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import { subscribe } from '../services/api';
import { useT } from '../i18n/LanguageContext';
import './Footer.css';

const T = {
    en: {
        tagline: 'Simplifying supply chains with expert solutions for importation, transit, and warehousing.',
        quickLinks: 'Quick Links',
        home: 'Home', store: 'Store', training: 'Training',
        warehousing: 'Warehousing', transit: 'Transit', contact: 'Contact',
        contactInfo: 'Contact Info',
        newsletter: 'Newsletter',
        newsletterText: 'Stay updated with our latest offerings',
        emailPlaceholder: 'Your email',
        subscribe: 'Subscribe',
        subscribed: 'Subscribed successfully!',
        subscribeFailed: 'Subscription failed',
        rights: (year) => `© ${year} ElecSolution. All rights reserved.`,
    },
    fr: {
        tagline: "Nous simplifions les chaînes d'approvisionnement avec des solutions expertes d'importation, de transit et d'entreposage.",
        quickLinks: 'Liens rapides',
        home: 'Accueil', store: 'Boutique', training: 'Formations',
        warehousing: 'Entreposage', transit: 'Transit', contact: 'Contact',
        contactInfo: 'Coordonnées',
        newsletter: 'Newsletter',
        newsletterText: 'Restez informé de nos dernières offres',
        emailPlaceholder: 'Votre e-mail',
        subscribe: "S'abonner",
        subscribed: 'Abonnement réussi !',
        subscribeFailed: "Échec de l'abonnement",
        rights: (year) => `© ${year} ElecSolution. Tous droits réservés.`,
    },
};

function Footer() {
    const [email, setEmail] = useState('');
    const [subMsg, setSubMsg] = useState('');
    const t = useT(T);

    const handleSubscribe = async (e) => {
        e.preventDefault();
        try {
            await subscribe(email);
            setSubMsg(t.subscribed);
            setEmail('');
        } catch (err) {
            setSubMsg(err.response?.data?.error || t.subscribeFailed);
        }
        setTimeout(() => setSubMsg(''), 3000);
    };

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-section">
                    <h3><span className="logo-elec">Elec</span><span className="logo-sol">Solution</span></h3>
                    <p>{t.tagline}</p>
                    <div className="social-links">
                        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebook /></a>
                        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
                        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
                        <a href="https://wa.me/" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
                    </div>
                </div>
                <div className="footer-section">
                    <h4>{t.quickLinks}</h4>
                    <Link to="/">{t.home}</Link>
                    <Link to="/products">{t.store}</Link>
                    <Link to="/training">{t.training}</Link>
                    <Link to="/warehousing">{t.warehousing}</Link>
                    <Link to="/transit">{t.transit}</Link>
                    <Link to="/contact">{t.contact}</Link>
                </div>
                <div className="footer-section">
                    <h4>{t.contactInfo}</h4>
                    <p><FaMapMarkerAlt /> Yaounde & Douala, Cameroon</p>
                    <p><FaPhone /> +237 696 466 958</p>
                    <p><FaEnvelope /> info@elecsolution.com</p>
                </div>
                <div className="footer-section">
                    <h4>{t.newsletter}</h4>
                    <p>{t.newsletterText}</p>
                    <form onSubmit={handleSubscribe} className="newsletter-form">
                        <input
                            type="email"
                            placeholder={t.emailPlaceholder}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <button type="submit">{t.subscribe}</button>
                    </form>
                    {subMsg && <p className="sub-msg">{subMsg}</p>}
                </div>
            </div>
            <div className="footer-bottom">
                <p>{t.rights(new Date().getFullYear())}</p>
            </div>
        </footer>
    );
}

export default Footer;
